import { SalaryComponent } from 'components/SalaryComponents/types';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import { ValidationSchema } from 'forms';
import { PreviewCTCBreakdown, SalaryStructureFormData } from './types';
import { PayrollStagingData } from 'api/gql-utils/payDetails/compensationTypes';
import { statutoryComponentNameMap } from './constants';

/**
 * Converts a salary component from API to structure component format
 */
export const convertToStructureComponent = (
  component: SalaryComponent,
): SalaryStructureComponent => {
  return {
    id: component.id,
    salaryComponent: component,
    valueType: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC',
    salaryComponentId: component.id,
  };
};

export const basicDetailsStepValidationSchema: ValidationSchema<SalaryStructureFormData> = {
  name: (formData) => {
    if (!formData.name) {
      return 'Name is required';
    }
    return null;
  },
  description: (formData) => {
    if (!formData.description) {
      return 'Description is required';
    }
    return null;
  },
  templateId: (formData) => {
    if (
      formData.creationType &&
      formData.creationType === 'from-existing' &&
      !formData.templateId
    ) {
      return 'Please select a template';
    }
    return null;
  },
};

export const structureDetailsStepValidationSchema: ValidationSchema<SalaryStructureFormData> = {
  name: (formData) => {
    if (!formData.name) {
      return 'Name is required';
    }
    return null;
  },
  description: (formData) => {
    if (!formData.description) {
      return 'Description is required';
    }
    return null;
  },
  components: (formData) => {
    const structureComponents = formData.components || [];
    const salaryComponents = Object.values(structureComponents);
    if (!salaryComponents.length) {
      return 'Components are required';
    }

    return null;
  },
};

export const getPreviewCTCData = (payrollData?: PayrollStagingData) => {
  const ctcComponent = payrollData?.compensation.ctcComponent;
  const earningComponents = ctcComponent?.earningComponents;

  const statutoryComponents = ctcComponent?.statutoryComponents;

  const nonPayableBenefits =
    earningComponents?.filter((earning) => earning.payType === 'non_payable_benefit') ?? [];

  const fixedDataArray = earningComponents
    ? earningComponents
        .filter((earning) => earning.payType === 'fixed')
        .map((earning, idx) => ({ ...earning, id: `earning_${idx}_${earning.name}` }))
    : [];

  const variableDataArray = earningComponents
    ? earningComponents
        .filter((earning) => earning.payType === 'variable')
        .map((earning, idx) => ({ ...earning, id: `variable_${idx}_${earning.name}` }))
    : [];

  const otherCtcDataArray = statutoryComponents
    ? statutoryComponents.map((component, idx) => ({
        id: `statutory_${idx}`,
        name: statutoryComponentNameMap[component.type],
        amount: component.amount,
      }))
    : [];

  // include Non Payable Benefits in Other CTC Data
  otherCtcDataArray.push(
    ...(earningComponents
      ? nonPayableBenefits.map((earning) => ({
          id: `non_payable_benefit_${earning.name}`,
          name: earning.displayBehaviourV1?.displayName ?? earning.name,
          amount: earning.amount,
        }))
      : []),
  );

  const ctcBreakdownData: PreviewCTCBreakdown = {
    fixed: fixedDataArray,

    variable: variableDataArray,

    otherCtc: otherCtcDataArray,
  };
  return ctcBreakdownData;
};
